interface PhasePlaceholderProps {
  title: string;
  phase: number;
  /** The acceptance criteria this page will have to satisfy, straight from the spec. */
  criteria: readonly string[];
}

/**
 * A page that exists so the navigation is final from day one, but which is
 * honest about not being built yet. Each one lists the acceptance criteria it
 * owes, so the next phase starts from a checklist rather than a blank file.
 */
export function PhasePlaceholder({ title, phase, criteria }: PhasePlaceholderProps) {
  return (
    <section className="card">
      <div className="card__header">
        <h1 className="card__title">{title}</h1>
        <span className="badge badge--phase">{phase}. fázis</span>
      </div>
      <p className="muted">Ez a nézet még nincs megépítve. Amit teljesítenie kell:</p>
      <ul className="criteria">
        {criteria.map((criterion) => (
          <li key={criterion}>{criterion}</li>
        ))}
      </ul>
    </section>
  );
}
